import axios from "axios";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useAppContext } from "../../contexts/AppContext";
const LanguageList = ({
  languages,
  setLanguages,
  selectedLanguage,
  setSelectedLanguage,
  goNext,
}) => {
   const { currentUser } = useAppContext();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getAllLanguages();
  }, []);

  const getAllLanguages = async () => {
    setLoading(true);
    const response = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN}/course/language${window.location.search}`,
    );
      if (!currentUser.isPowerUser && currentUser.activeTrainingRequirement) {

  
if(currentUser.AHCASEligible===1)
  {
const result = response.data.languages.filter(x =>x.trainingprogram ==="Advanced Training (AHCAS)");
setLanguages(result);
    setLoading(false);
  }  
  else{
   
const result = response.data.languages.filter(x =>x.trainingprogram ===currentUser.activeTrainingRequirement);
if(result===null || result.length===0)
{

// setLanguages(response.data.languages.filter(x=>x.trainingprogram===null));
     setLoading(false);
}
else{
setLanguages(result);
    setLoading(false);
}

  } 

      }
      else{
        if (!currentUser.isPowerUser)
        {
          if(currentUser.AHCASEligible===1)
  {
const result = response.data.languages.filter(x =>x.trainingprogram ==="Advanced Training (AHCAS)");
setLanguages(result);
    setLoading(false);
  } 
  else{
 setLoading(false);
  }

        }
        else{
   if(currentUser.AHCASEligible===1)
  {
const result = response.data.languages.filter(x =>x.trainingprogram ==="Advanced Training (AHCAS)");
setLanguages(result);
    setLoading(false);
  } 
  else{
setLanguages(response.data.languages.filter(x=>x.trainingprogram===null));
    setLoading(false);
  }
        }
     

      }

    
  };

  const handleChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  return (
    <div className="language-container">
      <div className="language-list">
              {loading ? (
                  <div className="text-center color-grey pt-5" style={{ marginLeft: "360px", display: "flex", justifyContent: "center" }}>
                      <Spinner animation="border" />
                  </div>
              ) : (
                  languages.map((language, index) => (
                      <label
                          key={index}
                          tabIndex={0}

                          onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                  const input = document.getElementById(index);
                                  if (input && !input.checked) input.click(); // triggers onChange
                              }
                          }}

              className={`language-option ${
                selectedLanguage === language.languagecode ? "selected" : ""
              }`}
            >
              <input
              id={index}
                type="radio"
                name="language"
                value={language.languagecode}
                checked={selectedLanguage === language.languagecode}
                onChange={handleChange}
              />
              <span className="custom-radio" />
              <span style={{ fontSize: "16px" }}>{language.languagename}</span>
            </label>
          ))
        )}
      </div>
      {languages && (
        <button
          disabled={!selectedLanguage}
          onClick={goNext}
          className={`button mt-4 ${
            !selectedLanguage ? "button-disabled" : ""
          }`}
          style={{ width: "150px" }}
        >
          Next
        </button>
      )}
    </div>
  );
};

export default LanguageList;
